import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/unified-client/layouts/default.vue").then(m => m.default || m)),
  "up-layout": defineAsyncComponent(() => import("/unified-client/layouts/upLayout.vue").then(m => m.default || m))
}